import { PdfContentData } from '../../../types/contentTypes';
import { useStorageFileUrl } from '../../../utils/hooks';
import PDFViewer from '../../molecules/pdf-viewer/PDFViewer';

interface PDFContentProps {
  content: PdfContentData;
  onComplete: (() => void) | undefined;
}

function PDFContent({ content, onComplete }: PDFContentProps) {
  const storagePathUrl = useStorageFileUrl(content.storagePath);

  return (
    <section>
      <h2 className="strong-heading mb-8">{content.headline}</h2>
      {storagePathUrl && <PDFViewer url={storagePathUrl} />}
    </section>
  );
}

export default PDFContent;
